export default __webpack_public_path__ + "assets/images/bfd91426123810fa36a2c63e64517349.svg";